module.exports = __webpack_public_path__ + "img/idcard.05e1b4c6.svg";